/*
 * SQD Athletica product page: variant selection, gallery, sticky add-to-cart,
 * add to cart and the Complete the look panel.
 */
(function() {
  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function moneyShort(cents) {
    return money(cents).replace(/[.,]00$/, '');
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    });
  }

  function findVariant(variants, options) {
    return variants.find(function(variant) {
      return variant.options.every(function(value, index) {
        return value === options[index];
      });
    });
  }

  function initProduct(root) {
    if (root.sqdProduct) return;

    // A product page has one product, so look across the whole document. Unbalanced HTML in a
    // product description can push later parts of the section outside its wrapper.
    var scope = document;
    var dataEl = scope.querySelector('[data-sqd-product-json]');
    if (!dataEl) return;
    root.sqdProduct = true;

    var product = JSON.parse(dataEl.textContent);
    var colorIndex = Number(root.dataset.colorIndex);
    var form = scope.querySelector('[data-sqd-product-form]');
    var idInput = scope.querySelector('[data-sqd-variant-id]');
    var optionGroups = Array.prototype.slice.call(scope.querySelectorAll('[data-sqd-option]'));
    var gallery = scope.querySelector('[data-sqd-gallery]');
    var thumbs = scope.querySelector('[data-sqd-gallery-thumbs]');
    var sticky = scope.querySelector('[data-sqd-sticky]');
    var addButtons = scope.querySelectorAll('[data-sqd-add]');
    var currentVariant = product.variants.find(function(v) { return String(v.id) === idInput.value; }) || product.variants[0];

    // Remembered so the page can be set up again if these elements are ever replaced
    root.sqdRefs = [form, idInput, optionGroups[0], addButtons[0]].filter(Boolean);
    var lastColor = colorIndex > -1 && currentVariant ? currentVariant.options[colorIndex] : '';

    /* Variant selection
       Options with no choice yet are null. Sizes start unselected, so the shopper is
       prompted to choose before anything can be added to the cart.
       ---------------------------------------------------------------- */
    function selectedOptions() {
      var options = product.options.map(function() { return null; });
      if (!optionGroups.length && currentVariant) return currentVariant.options.slice();
      optionGroups.forEach(function(group) {
        var checked = group.querySelector('input:checked');
        if (checked) options[Number(group.dataset.optionIndex)] = checked.value;
      });
      return options;
    }

    function matches(variant, options) {
      return options.every(function(value, index) {
        return value === null || variant.options[index] === value;
      });
    }

    function missingGroups(options) {
      return optionGroups.filter(function(group) {
        return options[Number(group.dataset.optionIndex)] === null;
      });
    }

    function updateGallery(color) {
      if (!gallery) return;

      var visible = [];
      gallery.querySelectorAll('[data-sqd-gallery-item]').forEach(function(item) {
        var show = colorIndex < 0 || item.dataset.color === color || item.dataset.color === '';
        item.hidden = !show;
        item.classList.remove('is-first');
        if (show) visible.push(item);
      });
      if (visible.length) visible[0].classList.add('is-first');
      gallery.scrollLeft = 0;

      // Desktop shows the first few images, with a button for the rest
      var limit = Number(gallery.dataset.limit) || 4;
      gallery.querySelectorAll('[data-sqd-gallery-item]').forEach(function(item) {
        item.classList.remove('is-extra');
      });
      visible.forEach(function(item, index) {
        item.classList.toggle('is-extra', index >= limit);
      });
      gallery.classList.remove('is-expanded');
      var moreWrap = scope.querySelector('[data-sqd-gallery-more-wrap]');
      if (moreWrap) moreWrap.hidden = visible.length <= limit;

      if (thumbs) {
        thumbs.querySelectorAll('li').forEach(function(thumb) {
          thumb.hidden = !(colorIndex < 0 || thumb.dataset.color === color || thumb.dataset.color === '');
        });
        setActiveThumb(visible.length ? visible[0].dataset.mediaId : null);
      }
    }

    function updateAvailability(options) {
      optionGroups.forEach(function(group) {
        var index = Number(group.dataset.optionIndex);
        group.querySelectorAll('input').forEach(function(input) {
          var test = options.slice();
          test[index] = input.value;
          var available = product.variants.some(function(variant) {
            return variant.available && matches(variant, test);
          });
          var label = scope.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    }

    // "Only X left" message for the chosen variant, when it is running low
    function updateLowStock(variant) {
      var el = scope.querySelector('[data-sqd-low-stock]');
      if (!el) return;
      var left = variant && variant.available && product.lowStock ? product.lowStock[variant.id] : null;
      el.hidden = !left;
      el.textContent = left ? el.dataset.template.replace('{count}', left) : '';
    }

    function updateVariant() {
      var options = selectedOptions();
      var missing = missingGroups(options);
      var variant = missing.length ? null : (findVariant(product.variants, options) || null);
      // Used for price and image while a choice is still missing
      var displayVariant = variant
        || product.variants.find(function(v) { return v.available && matches(v, options); })
        || product.variants.find(function(v) { return matches(v, options); })
        || product.variants[0];
      currentVariant = variant;

      optionGroups.forEach(function(group) {
        var value = options[Number(group.dataset.optionIndex)];
        var valueEl = group.querySelector('[data-sqd-option-value]');
        if (valueEl) valueEl.textContent = '— ' + (value === null ? group.dataset.prompt : value);
        if (value !== null) group.classList.remove('is-missing');
      });

      updateAvailability(options);
      updateLowStock(variant);

      var color = colorIndex > -1 ? options[colorIndex] : '';
      if (color !== lastColor) {
        lastColor = color;
        updateGallery(color);
      }

      addButtons.forEach(function(button) {
        var label = button.querySelector('[data-sqd-add-label]');
        var text;
        if (missing.length) {
          button.disabled = false;
          text = missing[0].dataset.prompt;
        } else if (!variant) {
          button.disabled = true;
          text = label ? label.dataset.unavailable : '';
        } else {
          button.disabled = !variant.available;
          text = label ? (variant.available ? label.dataset.add : label.dataset.soldOut) : '';
        }
        if (label) label.textContent = text;
      });

      if (variant) {
        idInput.value = variant.id;
        showError(scope.querySelector('[data-sqd-add-error]'), '');
      }

      var priceEl = scope.querySelector('[data-sqd-price]');
      if (priceEl) {
        var html = '<span class="sqd-buybox__price-now">' + money(displayVariant.price) + '</span>';
        if (displayVariant.compare_at_price > displayVariant.price) {
          html += ' <s class="sqd-buybox__price-was">' + money(displayVariant.compare_at_price) + '</s>';
          html += ' <span class="sqd-buybox__price-save">Save ' + moneyShort(displayVariant.compare_at_price - displayVariant.price) + '</span>';
        }
        priceEl.innerHTML = html;
      }

      var afterpay = root.querySelector('[data-sqd-afterpay]');
      if (afterpay) {
        var instalments = Number(afterpay.dataset.instalments) || 4;
        var amount = afterpay.querySelector('[data-sqd-afterpay-amount]');
        if (amount) amount.textContent = money(Math.floor(displayVariant.price / instalments));
      }

      if (sticky) {
        var stickyVariant = sticky.querySelector('[data-sqd-sticky-variant]');
        var stickyPrice = sticky.querySelector('[data-sqd-sticky-price]');
        var stickyImage = sticky.querySelector('[data-sqd-sticky-image]');
        if (stickyVariant) stickyVariant.textContent = variant ? variant.title : (missing.length ? missing[0].dataset.prompt : '');
        if (stickyPrice) stickyPrice.textContent = money(displayVariant.price);
        if (stickyImage && displayVariant.featured_image) {
          stickyImage.src = displayVariant.featured_image.src;
          stickyImage.removeAttribute('srcset');
        }
      }

      if (variant && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function showError(el, message) {
      if (!el) return;
      el.textContent = message || '';
      el.hidden = !message;
    }

    // Point the shopper at the option they still need to choose
    function promptForMissing() {
      var missing = missingGroups(selectedOptions());
      if (!missing.length) return false;
      missing.forEach(function(group) { group.classList.add('is-missing'); });
      showError(scope.querySelector('[data-sqd-add-error]'), missing[0].dataset.prompt + ' to add this to your cart');
      missing[0].scrollIntoView({ block: 'center' });
      return true;
    }

    optionGroups.forEach(function(group) {
      group.addEventListener('change', updateVariant);
    });

    // Set the starting state: nothing is selectable for the cart until every option is chosen
    if (optionGroups.length) {
      currentVariant = missingGroups(selectedOptions()).length ? null : currentVariant;
      updateAvailability(selectedOptions());
    }
    updateLowStock(currentVariant);

    /* Gallery: mobile thumbnails and zoom
       ---------------------------------------------------------------- */
    function setActiveThumb(mediaId) {
      if (!thumbs) return;
      thumbs.querySelectorAll('[data-sqd-gallery-thumb]').forEach(function(button) {
        button.classList.toggle('is-active', button.dataset.sqdGalleryThumb === String(mediaId));
      });
    }

    if (gallery && thumbs) {
      thumbs.addEventListener('click', function(evt) {
        var button = evt.target.closest('[data-sqd-gallery-thumb]');
        if (!button) return;
        var item = gallery.querySelector('[data-media-id="' + button.dataset.sqdGalleryThumb + '"]');
        if (item) gallery.scrollTo({ left: item.offsetLeft - gallery.offsetLeft });
        setActiveThumb(button.dataset.sqdGalleryThumb);
      });

      var scrollTimer = null;
      gallery.addEventListener('scroll', function() {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function() {
          var items = Array.prototype.filter.call(gallery.querySelectorAll('[data-sqd-gallery-item]'), function(i) { return !i.hidden; });
          var index = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
          if (items[index]) setActiveThumb(items[index].dataset.mediaId);
        }, 80);
      }, { passive: true });

      var firstVisible = gallery.querySelector('[data-sqd-gallery-item]:not([hidden])');
      if (firstVisible) setActiveThumb(firstVisible.dataset.mediaId);
    }

    var moreButton = scope.querySelector('[data-sqd-gallery-more]');
    if (moreButton && gallery) {
      moreButton.addEventListener('click', function() {
        gallery.classList.add('is-expanded');
        moreButton.parentElement.hidden = true;
      });
    }

    var lightbox = scope.querySelector('[data-sqd-lightbox]');
    if (lightbox && lightbox.showModal) {
      var lightboxImage = lightbox.querySelector('[data-sqd-lightbox-image]');
      scope.addEventListener('click', function(evt) {
        var zoom = evt.target.closest('[data-sqd-zoom]');
        if (zoom) {
          if (!lightbox.isConnected || lightbox.open) return;
          lightboxImage.src = zoom.dataset.sqdZoom;
          lightbox.showModal();
        } else if (evt.target.closest('[data-sqd-lightbox-close]') || evt.target === lightbox || evt.target === lightboxImage) {
          lightbox.close();
        }
      });
    }

    /* Size guide link
       ---------------------------------------------------------------- */
    scope.querySelectorAll('[data-sqd-size-guide-link]').forEach(function(link) {
      var target = scope.querySelector('#sqd-size-guide');
      if (!target) {
        link.hidden = true;
        return;
      }
      link.addEventListener('click', function(evt) {
        evt.preventDefault();
        target.open = true;
        target.scrollIntoView({ block: 'center' });
      });
    });

    /* Add to cart
       ---------------------------------------------------------------- */
    if (form) {
      var errorEl = form.querySelector('[data-sqd-add-error]');
      form.addEventListener('submit', function(evt) {
        evt.preventDefault();
        if (promptForMissing()) return;
        if (!currentVariant || !currentVariant.available) return;

        showError(errorEl, '');
        addButtons.forEach(function(button) {
          var label = button.querySelector('[data-sqd-add-label]');
          button.classList.add('btn--loading');
          if (label) label.textContent = 'Adding…';
        });

        postJSON(theme.routes.cartAdd, { items: [{ id: currentVariant.id, quantity: 1 }] })
          .then(function() {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          })
          .catch(function(error) {
            showError(errorEl, error.message);
          })
          .then(function() {
            addButtons.forEach(function(button) {
              var label = button.querySelector('[data-sqd-add-label]');
              button.classList.remove('btn--loading');
              if (label) label.textContent = label.dataset.add;
            });
          });
      });
    }

    /* Sticky add-to-cart bar: shown once the main button has scrolled out of view above
       ---------------------------------------------------------------- */
    var mainAdd = form ? form.querySelector('[data-sqd-add]') : null;
    if (sticky && mainAdd && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.hidden = !show;
        document.documentElement.classList.toggle('sqd-sticky-atc-visible', show);
      }).observe(mainAdd);
    }

    /* Complete the look
       ---------------------------------------------------------------- */
    var look = scope.querySelector('[data-sqd-look]');
    if (!look) return;

    var panel = look.querySelector('.sqd-look__panel');
    var totalEl = look.querySelector('[data-sqd-look-total]');
    var hintEl = look.querySelector('[data-sqd-look-hint]');
    var lookAdd = look.querySelector('[data-sqd-look-add]');
    var lookError = look.querySelector('[data-sqd-look-error]');
    var opener = null;

    var rows = Array.prototype.map.call(look.querySelectorAll('[data-sqd-look-row]'), function(el) {
      var data = JSON.parse(el.querySelector('[data-sqd-look-json]').textContent);
      return {
        el: el,
        data: data,
        isCurrent: el.dataset.current === 'true',
        colorIndex: Number(el.dataset.colorIndex),
        included: true,
        options: data.options.map(function() { return null; })
      };
    });

    function rowVariant(row) {
      if (row.data.hasOnlyDefaultVariant) return row.data.variants[0];
      if (row.options.indexOf(null) > -1) return null;
      return findVariant(row.data.variants, row.options) || null;
    }

    function resetRow(row) {
      row.included = true;
      if (row.isCurrent) {
        row.options = selectedOptions();
      } else {
        row.options = row.data.options.map(function() { return null; });
        // Start on the first available colour, with no size chosen
        if (row.colorIndex > -1) {
          var firstAvailable = row.data.variants.find(function(v) { return v.available; }) || row.data.variants[0];
          row.options[row.colorIndex] = firstAvailable.options[row.colorIndex];
        }
        // Options with a single value need no choice
        row.el.querySelectorAll('[data-sqd-look-option]').forEach(function(group) {
          var buttons = group.querySelectorAll('button');
          if (buttons.length === 1) row.options[Number(group.dataset.optionIndex)] = buttons[0].dataset.value;
        });
      }
    }

    function renderRow(row) {
      var variant = rowVariant(row);
      row.el.classList.toggle('is-excluded', !row.included);
      row.el.querySelector('[data-sqd-look-include]').checked = row.included;

      row.el.querySelectorAll('[data-sqd-look-option]').forEach(function(group) {
        var index = Number(group.dataset.optionIndex);
        var valueEl = group.querySelector('[data-sqd-look-option-value]');
        if (valueEl) valueEl.textContent = row.options[index] ? ': ' + row.options[index] : '';

        group.querySelectorAll('button').forEach(function(button) {
          // A value is available when some in-stock variant has it alongside the chosen colour
          var available = row.data.variants.some(function(v) {
            if (!v.available || v.options[index] !== button.dataset.value) return false;
            if (row.colorIndex > -1 && index !== row.colorIndex && row.options[row.colorIndex]) {
              return v.options[row.colorIndex] === row.options[row.colorIndex];
            }
            return true;
          });
          var selected = row.options[index] === button.dataset.value;
          button.disabled = !available || !row.included;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected);
        });
      });

      var priceEl = row.el.querySelector('[data-sqd-look-price]');
      var priceVariant = variant || row.data.variants.find(function(v) { return v.available; }) || row.data.variants[0];
      if (priceEl) priceEl.textContent = moneyShort(priceVariant.price);

      var image = row.el.querySelector('[data-sqd-look-image]');
      var imageVariant = variant;
      if (!imageVariant && row.colorIndex > -1) {
        imageVariant = row.data.variants.find(function(v) { return v.options[row.colorIndex] === row.options[row.colorIndex] && v.featured_image; });
      }
      if (image && imageVariant && imageVariant.featured_image) {
        image.src = imageVariant.featured_image.src;
        image.removeAttribute('srcset');
      }
    }

    function renderLook() {
      var included = rows.filter(function(row) { return row.included; });
      var missing = [];
      var total = 0;

      rows.forEach(renderRow);

      included.forEach(function(row) {
        var variant = rowVariant(row);
        if (variant && variant.available) {
          total += variant.price;
        } else {
          missing.push(row.data.title);
          var fallback = row.data.variants.find(function(v) { return v.available; }) || row.data.variants[0];
          total += fallback.price;
        }
      });

      totalEl.textContent = moneyShort(total);
      if (!included.length) {
        hintEl.textContent = 'Select at least one product';
      } else if (missing.length) {
        hintEl.textContent = 'Choose a size for ' + missing.join(', ');
      } else {
        hintEl.textContent = 'All sizes selected';
      }

      lookAdd.textContent = 'Add ' + included.length + (included.length === 1 ? ' item' : ' items') + ' to cart';
      lookAdd.disabled = !included.length || missing.length > 0;
    }

    function openLook(evt) {
      opener = evt.currentTarget;
      rows.forEach(resetRow);
      showError(lookError, '');
      renderLook();
      look.hidden = false;
      document.documentElement.classList.add('sqd-look-open');
      panel.focus();
    }

    function closeLook() {
      look.hidden = true;
      document.documentElement.classList.remove('sqd-look-open');
      if (opener) opener.focus();
    }

    scope.querySelectorAll('[data-sqd-look-open]').forEach(function(button) {
      button.addEventListener('click', openLook);
    });

    look.addEventListener('click', function(evt) {
      if (evt.target.closest('[data-sqd-look-close]')) {
        closeLook();
        return;
      }

      var optionButton = evt.target.closest('.sqd-look-option__button');
      if (optionButton) {
        var rowEl = optionButton.closest('[data-sqd-look-row]');
        var row = rows.find(function(r) { return r.el === rowEl; });
        var index = Number(optionButton.closest('[data-sqd-look-option]').dataset.optionIndex);
        row.options[index] = optionButton.dataset.value;

        // Changing colour can make the chosen size unavailable: clear it so it is chosen again
        if (index === row.colorIndex) {
          var variant = rowVariant(row);
          if (variant && !variant.available) {
            row.options = row.options.map(function(value, i) { return i === row.colorIndex ? value : null; });
            row.el.querySelectorAll('[data-sqd-look-option]').forEach(function(group) {
              var buttons = group.querySelectorAll('button');
              if (buttons.length === 1) row.options[Number(group.dataset.optionIndex)] = buttons[0].dataset.value;
            });
          }
        }
        renderLook();
      }
    });

    look.addEventListener('change', function(evt) {
      if (!evt.target.matches('[data-sqd-look-include]')) return;
      var rowEl = evt.target.closest('[data-sqd-look-row]');
      var row = rows.find(function(r) { return r.el === rowEl; });
      row.included = evt.target.checked;
      renderLook();
    });

    document.addEventListener('keydown', function(evt) {
      if (evt.key === 'Escape' && !look.hidden) closeLook();
    });

    lookAdd.addEventListener('click', function() {
      var items = rows.filter(function(row) { return row.included; }).map(function(row) {
        return { id: rowVariant(row).id, quantity: 1 };
      });

      showError(lookError, '');
      lookAdd.disabled = true;
      lookAdd.classList.add('btn--loading');

      postJSON(theme.routes.cartAdd, { items: items })
        .then(function() {
          closeLook();
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        })
        .catch(function(error) {
          showError(lookError, error.message);
          lookAdd.disabled = false;
        })
        .then(function() {
          lookAdd.classList.remove('btn--loading');
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-sqd-product]').forEach(function(root) {
      // If the product markup was swapped out after load (theme editor, live preview
      // reloads, apps), the old listeners are gone with it: set the page up again
      var stale = root.sqdProduct && (root.sqdRefs || []).some(function(el) { return !el.isConnected; });
      if (stale) root.sqdProduct = false;
      initProduct(root);
    });
  }

  // Runs before the click, change or submit reaches the product controls, so a page whose
  // markup was replaced is ready by the time the control handles the event
  ['click', 'change', 'submit'].forEach(function(type) {
    document.addEventListener(type, init, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
